import {
  Spinner
} from "./chunk-YIKYS5LU.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/center-spinner/center-spinner.tsx
import React from "react";
var CenterSpinner = ({
  className,
  size = 40
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cn("mx-auto text-[theme(borderColor.focus)]", className),
    style: { width: size, height: size },
    "data-testid": "center-spinner"
  },
  /* @__PURE__ */ React.createElement(Spinner, null)
);

export {
  CenterSpinner
};
